import { View } from '@react-pdf/renderer'
import { Style } from '@react-pdf/types'
import React from 'react'
import { pdfTableCellTextStyle, pdfTableColStyle } from './PdfTableStyles'

interface PdfTableCellProps {
  style?: Style | Style[]
  children?: React.ReactNode
}

/**
 * Body cell of a PDF table, shares cell styling between all table form elements.
 */
export const PdfTableCell = ({ style = [], children }: PdfTableCellProps): React.ReactElement => (
  <View
    style={[pdfTableColStyle, pdfTableCellTextStyle, ...(Array.isArray(style) ? style : [style])]}
  >
    {children}
  </View>
)
